<template>
  <v-dialog
      v-model="showDialog"
      max-width="800px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{taskInternal.task_type === 'quick' ? (taskInternal.id ? 'Kurzzuweisung anpassen' : 'Kurzzuweisung erstellen') : (taskInternal.id ? 'Zuweisung anpassen' : 'Zuweisung erstellen')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field
              label="Name"
              v-model="taskInternal.task_name"
              counter
              maxlength="50"
              :disabled="taskInternal.task_type !== 'quick'"
          ></v-text-field>
          <v-textarea
              v-if="taskInternal.task_type === 'quick' || taskInternal.task_type === 'task' || taskInternal.task_type === 'tour'"
              label="Beschreibung"
              v-model="taskInternal.task_description"
              rows="2"
              row-height="30"
          ></v-textarea>
          <v-select v-if="!taskInternal.id && taskInternal.task_type === 'quick'"
              :items="legrs"
              label="Leistungsgruppe"
              item-text="name"
              item-value="gischl"
                    v-model="taskInternal.legr"
          ></v-select>
          <v-select
              class="blue-chips"
              v-model="taskInternal.planned_for"
              :items="possibleUsers"
              label="Beplant für"
              multiple
              chips
              item-text="name"
              item-value="id"
              deletable-chips
          ></v-select>
          <v-row>
            <v-col>
              <v-menu
                  ref="menuFrom"
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  :return-value.sync="taskInternal.from"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedFrom"
                      label="Ausführen ab:"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="taskInternal.from"
                    no-title
                    scrollable
                    :max="taskInternal.till"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="menuFrom = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menuFrom.save(taskInternal.from)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col>
              <v-menu
                  ref="menuTill"
                  v-model="menuTill"
                  :close-on-content-click="false"
                  :return-value.sync="taskInternal.till"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedTill"
                      label="Fertigstellen bis:"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="taskInternal.till"
                    no-title
                    scrollable
                    :min="taskInternal.from"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="menuTill = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menuTill.save(taskInternal.till)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-data-table
              v-if="this.taskInternal.task_type === 'tour' && !this.taskInternal.id"
              v-model="selected"
              :headers="headers"
              :items="tourItems"
              item-key="id"
              show-select
              class="elevation-1"
              :items-per-page="5"
          >
            <template v-slot:footer.prepend>
              <v-btn
                  icon
                  color=""
                  @click="openMap"
              >
                <v-icon>mdi-map-search</v-icon>
              </v-btn>
            </template>
            <template
                v-slot:header.data-table-select="{ on, props }"
            >
              <v-checkbox
                  :input-value="selected.length === tourItems.length"
                  :indeterminate="selected.length !== tourItems.length && selected.length > 0"
                  style="margin-top: 0px; padding-top: 0px"
                  hide-details
                  @click.native="toggleAll"
              ></v-checkbox>
            </template>

          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
            v-if="taskInternal.id"
            color="red darken-1"
            text
            @click="showDialog = false; $emit('delete', taskInternal.id)"
        >
          Zuweisung löschen
        </v-btn>
        <v-btn
            v-if="taskInternal.task_type === 'tour'"
            color="green darken-1"
            text
            @click="showDialog = false; $emit('show_tour', taskInternal.task_id)"
        >
          Tourstatus anzeigen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          {{taskInternal.id ? 'Speichern' : 'Anlegen'}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <task-map ref="task_map" @close-map="" @map_plan="toggle"></task-map>

  </v-dialog>

</template>

<script>

import Planning_map  from "@/views/planning/planning_map.vue";
export default {
  name: "QuickTaskDialog",
  components: {
    TaskMap: Planning_map,
  },
  props: {
    legrs: {
      type: Array,
      default: () => [],
    },
    possibleUsers: {
      type: Array,
      default: () => [],
    },
    task: {
      type: Object,
      default: () => {
        return {
          id: '',
          task_id: '',
          augr: '',
          aufisn: '',
          legr: '',
          task_name: '',
          task_description: '',
          from: null,
          till: new Date(),
          planned_for: [],
          task_type: 'quick'
        }
      },
    },
    tour_data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
      error: false,
      taskInternal: {
        id: '',
        task_id: '',
        augr: '',
        aufisn: '',
        legr: '',
        task_name: '',
        task_description: '',
        from: null,
        till: new Date(),
        planned_for: [],
        task_type: 'quick',
      },
      selected: [],
      menuFrom: false,
      menuTill: false,
      tourItems: [],
      headers: [
        {
          text: 'Teilaufgabe',
          align: 'start',
          value: 'subject',
        },
        { text: 'Anz. Planungen', value: 'planned' },
      ],
    }
  },
  computed: {
    canSubmit() {
      return this.taskInternal.till && this.taskInternal.task_name && this.taskInternal.planned_for.length > 0 && (this.taskInternal.task_type !== 'tour' || this.selected.length > 0 || this.taskInternal.id);
    },
    formatedFrom() {
      if (!this.taskInternal.from) return ''
      const [year, month, day] = this.taskInternal.from.split('-')
      return `${day}.${month}.${year}`
    },
    formatedTill() {
      if (!this.taskInternal.till) return 'Bitte setzen'
      const [year, month, day] = this.taskInternal.till.split('-')
      return `${day}.${month}.${year}`
    }
  },
  watch: {

  },
  methods: {
    openMap() {
      this.$refs.task_map.showMap(this.tourItems);
    },
    toggleAll () {
      this.selected = this.selected.length === this.tourItems.length
          ? []
          : this.tourItems
    },
    toggle(selected) {
      this.selected = this.tourItems.filter(item => selected.includes(item.id));
    },
    show() {
      if (this.showDialog) {
        return;
      }
      this.taskInternal = {...this.task};
      this.tourItems = [...this.tour_data.filter(item => item.completed === "")];
      this.selected = [...this.tourItems.filter(item => item.planned === 0)];
      console.log(this.taskInternal)
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.taskInternal, this.selected.length === this.tour_data.length || this.taskInternal.task_type !== 'tour' ? undefined : this.selected);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>
::v-deep .blue-chips .theme--light.v-chip:not(.v-chip--active) {
  background-color: #1976D2;
  color: white;
}

::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.87);
}


::v-deep .v-text-field .v-label {
  top: 0px;
}

</style>

